"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import 'react';
import styles from './Overlay.module.scss.mjs';
import clsx from 'clsx';
import 'mobx';
import { useOverlayController } from '../../lib/controller/overlay/useOverlayController.mjs';
import { OverlayContextProvider } from '../../lib/controller/overlay/OverlayContextProvider.mjs';
import OverlayContentView from '../../views/OverlayContentView.mjs';

const Overlay = (props) => {
  const {
    controller: controllerFromProps,
    children,
    isDismissable = true,
    className,
    overlayType = "Modal",
    ref
  } = props;
  const controllerFromContext = useOverlayController(overlayType, {
    reuseControllerFromContext: true
  });
  const controller = controllerFromProps ?? controllerFromContext;
  const isOpen = controller.useIsOpen();
  const rootClassName = clsx(styles.overlay, className);
  return /* @__PURE__ */ jsx(
    OverlayContentView,
    {
      onOpenChange: (isOpen2) => controller.setOpen(isOpen2),
      isOpen,
      ref,
      isDismissable,
      className: rootClassName,
      children: /* @__PURE__ */ jsx(OverlayContextProvider, { type: "Modal", controller, children: isOpen && children })
    }
  );
};

export { Overlay, Overlay as default };
//# sourceMappingURL=Overlay.mjs.map
